import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/agent/requirementsAgent/filter'; // Importing Filter component
import Table from 'views/agent/requirementsAgent/table'; // Importing Table component
import Details from 'views/agent/requirementsAgent/details'; // Importing Details component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the requirements agent view.
 * @extends JetView
 */
export default class requirementsAgentView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        const right = {
            // Configuration for the right panel
            type: 'wide',
            minWidth: 200,
            rows: [Details], // Including Details component
        };

        const toolbar = {
            // Configuration for the toolbar
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            if (value == 1) {
                                // Excel export
                                var table = $$('datatable');
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Requisitos'),
                                    ignore: {
                                        Action: true,
                                        detailTittle: true,
                                        ActionTittle: true,
                                    },
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Requisitos'),
                                        autowidth: true,
                                        ignore: {
                                            Action: true,
                                            detailTittle: true,
                                            ActionTittle: true,
                                        },
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };

        const left = {
            // Configuration for the left panel
            height: screen.width < 500 ? 500 : 0,
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme,
                    elements: [
                        { view: 'label', label: _('Requisitos') }, // Title label
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon', // Close icon
                                    icon: 'wxi-close',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigate on click
                                },
                            ],
                        },
                    ],
                },
                Filter, // Including Filter component
                Table, // Including Table component
                toolbar, // Including toolbar
            ],
        };

        const avanc = {
            // Configuration for advanced details accordion
            view: 'accordion',
            multi: true,
            collapsed: true,
            cols: [{ header: _('Detalles Avanzados'), body: right }], // Right panel as body
        };

        const avancResp = {
            // Responsive advanced details accordion
            view: 'accordion',
            multi: true,
            collapsed: true,
            rows: [
                {
                    id: 'dColl',
                    header: _('Detalles Avanzados'),
                    body: right,
                    on: {
                        onItemClick: function () {
                            // Event handler for item click
                            var height;
                            $(function () {
                                height =
                                    $('.scrolling > .webix_scroll_cont').height() -
                                    $('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                if (!$$('dColl').config.collapsed) {
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)',
                                    });
                                } else {
                                    height =
                                        $('.scrolling > .webix_scroll_cont').height() -
                                        $('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)',
                                    });
                                }
                            });
                        },
                    },
                },
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        return {
            // Main layout configuration
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [
                        left, // Left panel
                        { id: 'res', view: 'resizer' }, // Resizer between panels
                        document.body.offsetWidth < 500 ? avancResp : avanc, // Responsive advanced details
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500) {
                $$('res').hide(); // Hide resizer on small screens
            }
        });
    }
}

// FILE DOCUMENTED
